/* tslint:disable */
/* eslint-disable */
/**
 * OpenShifts.WebApi
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, AxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError } from '../base';
// @ts-ignore
import { BaseResponseOfIEnumerableOfGetUnitsResponse } from '../api-models';
// @ts-ignore
import { BaseResponseOfIEnumerableOfViewPositionDto } from '../api-models';
// @ts-ignore
import { BaseResponseOfIEnumerableOfViewUnitDto } from '../api-models';
// @ts-ignore
import { BaseResponseOfViewPositionDto } from '../api-models';
// @ts-ignore
import { UpdatePositionDto } from '../api-models';
// @ts-ignore
import { ViewDepartmentDto } from '../api-models';
// @ts-ignore
import { ViewFacilityDto } from '../api-models';
/**
 * LaborLevelApi - axios parameter creator
 * @export
 */
export const LaborLevelApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Retrieves a list of positions filtered by the optional facility ID.
         * @param {number} [facilityId] Optional. A facility ID to filter the positions. If null, positions from all facilities are retrieved.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        laborLevelBudgetGroupGet: async (facilityId?: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/LaborLevel/BudgetGroup`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (facilityId !== undefined) {
                localVarQueryParameter['facilityId'] = facilityId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        laborLevelBudgetGroupIdGet: async (id: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('laborLevelBudgetGroupIdGet', 'id', id)
            const localVarPath = `/LaborLevel/BudgetGroup/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {UpdatePositionDto} [updatePositionDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        laborLevelBudgetGroupIdPut: async (id: number, updatePositionDto?: UpdatePositionDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('laborLevelBudgetGroupIdPut', 'id', id)
            const localVarPath = `/LaborLevel/BudgetGroup/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updatePositionDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} [positionId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        laborLevelCoveringBudgetgroupsGet: async (positionId?: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/LaborLevel/covering-budgetgroups`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (positionId !== undefined) {
                localVarQueryParameter['positionId'] = positionId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} [facilityId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        laborLevelDepartmentsGet: async (facilityId?: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/LaborLevel/Departments`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (facilityId !== undefined) {
                localVarQueryParameter['facilityId'] = facilityId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {boolean} [filteredByOpeningTemplates] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        laborLevelFacilitiesGet: async (filteredByOpeningTemplates?: boolean, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/LaborLevel/Facilities`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (filteredByOpeningTemplates !== undefined) {
                localVarQueryParameter['filteredByOpeningTemplates'] = filteredByOpeningTemplates;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Retrieves a list of units based on the provided facility ID.
         * @param {number} [facilityId] Optional parameter to filter units by a specific facility ID. If null, retrieves all units.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        laborLevelFloorGet: async (facilityId?: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/LaborLevel/Floor`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (facilityId !== undefined) {
                localVarQueryParameter['facilityId'] = facilityId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} [employeeId] 
         * @param {number} [positionId] 
         * @param {number} [shiftTypeId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        laborLevelFloorsByShiftTypeAndPositionGet: async (employeeId?: number, positionId?: number, shiftTypeId?: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/LaborLevel/floors-by-shift-type-and-position`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (employeeId !== undefined) {
                localVarQueryParameter['employeeId'] = employeeId;
            }

            if (positionId !== undefined) {
                localVarQueryParameter['positionId'] = positionId;
            }

            if (shiftTypeId !== undefined) {
                localVarQueryParameter['shiftTypeId'] = shiftTypeId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * LaborLevelApi - functional programming interface
 * @export
 */
export const LaborLevelApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = LaborLevelApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Retrieves a list of positions filtered by the optional facility ID.
         * @param {number} [facilityId] Optional. A facility ID to filter the positions. If null, positions from all facilities are retrieved.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async laborLevelBudgetGroupGet(facilityId?: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BaseResponseOfIEnumerableOfViewPositionDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.laborLevelBudgetGroupGet(facilityId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async laborLevelBudgetGroupIdGet(id: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BaseResponseOfViewPositionDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.laborLevelBudgetGroupIdGet(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} id 
         * @param {UpdatePositionDto} [updatePositionDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async laborLevelBudgetGroupIdPut(id: number, updatePositionDto?: UpdatePositionDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BaseResponseOfViewPositionDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.laborLevelBudgetGroupIdPut(id, updatePositionDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} [positionId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async laborLevelCoveringBudgetgroupsGet(positionId?: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BaseResponseOfIEnumerableOfViewPositionDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.laborLevelCoveringBudgetgroupsGet(positionId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} [facilityId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async laborLevelDepartmentsGet(facilityId?: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ViewDepartmentDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.laborLevelDepartmentsGet(facilityId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {boolean} [filteredByOpeningTemplates] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async laborLevelFacilitiesGet(filteredByOpeningTemplates?: boolean, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ViewFacilityDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.laborLevelFacilitiesGet(filteredByOpeningTemplates, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Retrieves a list of units based on the provided facility ID.
         * @param {number} [facilityId] Optional parameter to filter units by a specific facility ID. If null, retrieves all units.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async laborLevelFloorGet(facilityId?: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BaseResponseOfIEnumerableOfViewUnitDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.laborLevelFloorGet(facilityId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} [employeeId] 
         * @param {number} [positionId] 
         * @param {number} [shiftTypeId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async laborLevelFloorsByShiftTypeAndPositionGet(employeeId?: number, positionId?: number, shiftTypeId?: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BaseResponseOfIEnumerableOfGetUnitsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.laborLevelFloorsByShiftTypeAndPositionGet(employeeId, positionId, shiftTypeId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * LaborLevelApi - factory interface
 * @export
 */
export const LaborLevelApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = LaborLevelApiFp(configuration)
    return {
        /**
         * 
         * @summary Retrieves a list of positions filtered by the optional facility ID.
         * @param {LaborLevelApiLaborLevelBudgetGroupGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        laborLevelBudgetGroupGet(requestParameters: LaborLevelApiLaborLevelBudgetGroupGetRequest = {}, options?: AxiosRequestConfig): AxiosPromise<BaseResponseOfIEnumerableOfViewPositionDto> {
            return localVarFp.laborLevelBudgetGroupGet(requestParameters.facilityId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {LaborLevelApiLaborLevelBudgetGroupIdGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        laborLevelBudgetGroupIdGet(requestParameters: LaborLevelApiLaborLevelBudgetGroupIdGetRequest, options?: AxiosRequestConfig): AxiosPromise<BaseResponseOfViewPositionDto> {
            return localVarFp.laborLevelBudgetGroupIdGet(requestParameters.id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {LaborLevelApiLaborLevelBudgetGroupIdPutRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        laborLevelBudgetGroupIdPut(requestParameters: LaborLevelApiLaborLevelBudgetGroupIdPutRequest, options?: AxiosRequestConfig): AxiosPromise<BaseResponseOfViewPositionDto> {
            return localVarFp.laborLevelBudgetGroupIdPut(requestParameters.id, requestParameters.updatePositionDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {LaborLevelApiLaborLevelCoveringBudgetgroupsGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        laborLevelCoveringBudgetgroupsGet(requestParameters: LaborLevelApiLaborLevelCoveringBudgetgroupsGetRequest = {}, options?: AxiosRequestConfig): AxiosPromise<BaseResponseOfIEnumerableOfViewPositionDto> {
            return localVarFp.laborLevelCoveringBudgetgroupsGet(requestParameters.positionId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {LaborLevelApiLaborLevelDepartmentsGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        laborLevelDepartmentsGet(requestParameters: LaborLevelApiLaborLevelDepartmentsGetRequest = {}, options?: AxiosRequestConfig): AxiosPromise<Array<ViewDepartmentDto>> {
            return localVarFp.laborLevelDepartmentsGet(requestParameters.facilityId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {LaborLevelApiLaborLevelFacilitiesGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        laborLevelFacilitiesGet(requestParameters: LaborLevelApiLaborLevelFacilitiesGetRequest = {}, options?: AxiosRequestConfig): AxiosPromise<Array<ViewFacilityDto>> {
            return localVarFp.laborLevelFacilitiesGet(requestParameters.filteredByOpeningTemplates, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Retrieves a list of units based on the provided facility ID.
         * @param {LaborLevelApiLaborLevelFloorGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        laborLevelFloorGet(requestParameters: LaborLevelApiLaborLevelFloorGetRequest = {}, options?: AxiosRequestConfig): AxiosPromise<BaseResponseOfIEnumerableOfViewUnitDto> {
            return localVarFp.laborLevelFloorGet(requestParameters.facilityId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {LaborLevelApiLaborLevelFloorsByShiftTypeAndPositionGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        laborLevelFloorsByShiftTypeAndPositionGet(requestParameters: LaborLevelApiLaborLevelFloorsByShiftTypeAndPositionGetRequest = {}, options?: AxiosRequestConfig): AxiosPromise<BaseResponseOfIEnumerableOfGetUnitsResponse> {
            return localVarFp.laborLevelFloorsByShiftTypeAndPositionGet(requestParameters.employeeId, requestParameters.positionId, requestParameters.shiftTypeId, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for laborLevelBudgetGroupGet operation in LaborLevelApi.
 * @export
 * @interface LaborLevelApiLaborLevelBudgetGroupGetRequest
 */
export interface LaborLevelApiLaborLevelBudgetGroupGetRequest {
    /**
     * Optional. A facility ID to filter the positions. If null, positions from all facilities are retrieved.
     * @type {number}
     * @memberof LaborLevelApiLaborLevelBudgetGroupGet
     */
    readonly facilityId?: number
}

/**
 * Request parameters for laborLevelBudgetGroupIdGet operation in LaborLevelApi.
 * @export
 * @interface LaborLevelApiLaborLevelBudgetGroupIdGetRequest
 */
export interface LaborLevelApiLaborLevelBudgetGroupIdGetRequest {
    /**
     * 
     * @type {number}
     * @memberof LaborLevelApiLaborLevelBudgetGroupIdGet
     */
    readonly id: number
}

/**
 * Request parameters for laborLevelBudgetGroupIdPut operation in LaborLevelApi.
 * @export
 * @interface LaborLevelApiLaborLevelBudgetGroupIdPutRequest
 */
export interface LaborLevelApiLaborLevelBudgetGroupIdPutRequest {
    /**
     * 
     * @type {number}
     * @memberof LaborLevelApiLaborLevelBudgetGroupIdPut
     */
    readonly id: number

    /**
     * 
     * @type {UpdatePositionDto}
     * @memberof LaborLevelApiLaborLevelBudgetGroupIdPut
     */
    readonly updatePositionDto?: UpdatePositionDto
}

/**
 * Request parameters for laborLevelCoveringBudgetgroupsGet operation in LaborLevelApi.
 * @export
 * @interface LaborLevelApiLaborLevelCoveringBudgetgroupsGetRequest
 */
export interface LaborLevelApiLaborLevelCoveringBudgetgroupsGetRequest {
    /**
     * 
     * @type {number}
     * @memberof LaborLevelApiLaborLevelCoveringBudgetgroupsGet
     */
    readonly positionId?: number
}

/**
 * Request parameters for laborLevelDepartmentsGet operation in LaborLevelApi.
 * @export
 * @interface LaborLevelApiLaborLevelDepartmentsGetRequest
 */
export interface LaborLevelApiLaborLevelDepartmentsGetRequest {
    /**
     * 
     * @type {number}
     * @memberof LaborLevelApiLaborLevelDepartmentsGet
     */
    readonly facilityId?: number
}

/**
 * Request parameters for laborLevelFacilitiesGet operation in LaborLevelApi.
 * @export
 * @interface LaborLevelApiLaborLevelFacilitiesGetRequest
 */
export interface LaborLevelApiLaborLevelFacilitiesGetRequest {
    /**
     * 
     * @type {boolean}
     * @memberof LaborLevelApiLaborLevelFacilitiesGet
     */
    readonly filteredByOpeningTemplates?: boolean
}

/**
 * Request parameters for laborLevelFloorGet operation in LaborLevelApi.
 * @export
 * @interface LaborLevelApiLaborLevelFloorGetRequest
 */
export interface LaborLevelApiLaborLevelFloorGetRequest {
    /**
     * Optional parameter to filter units by a specific facility ID. If null, retrieves all units.
     * @type {number}
     * @memberof LaborLevelApiLaborLevelFloorGet
     */
    readonly facilityId?: number
}

/**
 * Request parameters for laborLevelFloorsByShiftTypeAndPositionGet operation in LaborLevelApi.
 * @export
 * @interface LaborLevelApiLaborLevelFloorsByShiftTypeAndPositionGetRequest
 */
export interface LaborLevelApiLaborLevelFloorsByShiftTypeAndPositionGetRequest {
    /**
     * 
     * @type {number}
     * @memberof LaborLevelApiLaborLevelFloorsByShiftTypeAndPositionGet
     */
    readonly employeeId?: number

    /**
     * 
     * @type {number}
     * @memberof LaborLevelApiLaborLevelFloorsByShiftTypeAndPositionGet
     */
    readonly positionId?: number

    /**
     * 
     * @type {number}
     * @memberof LaborLevelApiLaborLevelFloorsByShiftTypeAndPositionGet
     */
    readonly shiftTypeId?: number
}

/**
 * LaborLevelApi - object-oriented interface
 * @export
 * @class LaborLevelApi
 * @extends {BaseAPI}
 */
export class LaborLevelApi extends BaseAPI {
    /**
     * 
     * @summary Retrieves a list of positions filtered by the optional facility ID.
     * @param {LaborLevelApiLaborLevelBudgetGroupGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LaborLevelApi
     */
    public laborLevelBudgetGroupGet(requestParameters: LaborLevelApiLaborLevelBudgetGroupGetRequest = {}, options?: AxiosRequestConfig) {
        return LaborLevelApiFp(this.configuration).laborLevelBudgetGroupGet(requestParameters.facilityId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {LaborLevelApiLaborLevelBudgetGroupIdGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LaborLevelApi
     */
    public laborLevelBudgetGroupIdGet(requestParameters: LaborLevelApiLaborLevelBudgetGroupIdGetRequest, options?: AxiosRequestConfig) {
        return LaborLevelApiFp(this.configuration).laborLevelBudgetGroupIdGet(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {LaborLevelApiLaborLevelBudgetGroupIdPutRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LaborLevelApi
     */
    public laborLevelBudgetGroupIdPut(requestParameters: LaborLevelApiLaborLevelBudgetGroupIdPutRequest, options?: AxiosRequestConfig) {
        return LaborLevelApiFp(this.configuration).laborLevelBudgetGroupIdPut(requestParameters.id, requestParameters.updatePositionDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {LaborLevelApiLaborLevelCoveringBudgetgroupsGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LaborLevelApi
     */
    public laborLevelCoveringBudgetgroupsGet(requestParameters: LaborLevelApiLaborLevelCoveringBudgetgroupsGetRequest = {}, options?: AxiosRequestConfig) {
        return LaborLevelApiFp(this.configuration).laborLevelCoveringBudgetgroupsGet(requestParameters.positionId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {LaborLevelApiLaborLevelDepartmentsGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LaborLevelApi
     */
    public laborLevelDepartmentsGet(requestParameters: LaborLevelApiLaborLevelDepartmentsGetRequest = {}, options?: AxiosRequestConfig) {
        return LaborLevelApiFp(this.configuration).laborLevelDepartmentsGet(requestParameters.facilityId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {LaborLevelApiLaborLevelFacilitiesGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LaborLevelApi
     */
    public laborLevelFacilitiesGet(requestParameters: LaborLevelApiLaborLevelFacilitiesGetRequest = {}, options?: AxiosRequestConfig) {
        return LaborLevelApiFp(this.configuration).laborLevelFacilitiesGet(requestParameters.filteredByOpeningTemplates, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Retrieves a list of units based on the provided facility ID.
     * @param {LaborLevelApiLaborLevelFloorGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LaborLevelApi
     */
    public laborLevelFloorGet(requestParameters: LaborLevelApiLaborLevelFloorGetRequest = {}, options?: AxiosRequestConfig) {
        return LaborLevelApiFp(this.configuration).laborLevelFloorGet(requestParameters.facilityId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {LaborLevelApiLaborLevelFloorsByShiftTypeAndPositionGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LaborLevelApi
     */
    public laborLevelFloorsByShiftTypeAndPositionGet(requestParameters: LaborLevelApiLaborLevelFloorsByShiftTypeAndPositionGetRequest = {}, options?: AxiosRequestConfig) {
        return LaborLevelApiFp(this.configuration).laborLevelFloorsByShiftTypeAndPositionGet(requestParameters.employeeId, requestParameters.positionId, requestParameters.shiftTypeId, options).then((request) => request(this.axios, this.basePath));
    }
}
